module.exports = __webpack_public_path__ + "files/89d3830deec13a338ac1d97bde779ebe.png";